<template>
  <div id="windraftausbau-hessen-map" :class="{webkit: webkit}">
    <div class="mapHeader" @click="toggleDescription">
      <div class="dz">Energiewende in Hessen</div>
      <div class="hl">Wo könnte in Ihrer Nähe das nächste Windrad&nbsp;stehen?</div>
      <div class="infoButton">i</div>
    </div>
    <div class="lightbox" v-if="descriptionOpen">
      <div class="closeButton" @click="toggleDescription">✕</div>
      <p>
        <b>Was zeigt die Karte?</b><br>
        An welchen Orten werden sich künftig besonders viele Windräder drehen? Wo könnte in Ihrer Nähe das nächste stehen? In unserer interaktiven Karte sehen Sie, welche Regionen sich in Hessen für die Windkraft eignen. Die blauen Flächen kennzeichnen Windpotentialfächen – hier gibt es ausreichend Wind und genügend Abstand zu Siedlungen und anderen Ausschlussflächen. In den gelben Flächen ist zukünftig der Bau von Windkraftanlagen erlaubt, diese Gebiete sind vom Land Hessen als Windvorrangflächen ausgewiesen.</p>
      <p>
        Mehr über die Chancen und Hürden für die Windkraft in Hessen erfahren Sie auch in unserer Multimedia-Reportage:
      </p>
      <a class="articleTeaser" onclick="location.href='https://www.faz.net/1.8169429';">
        <div class="articleTeaser_image">
          <img src="https://media1.faz.net/ppmedia/1973474622/1.7670377/article_multimedia_overview/windraeder-auf-einem-feld-in.jpg"/>
        </div>        
        <div class="articleTeaser_text">
          <!-- <div class="dz">Windkraftausbau in Hessen</div> -->
          <div class="hl">Wohin mit all den Windrädern?</div>
          <div class="teaser">Zwei Prozent der Landesfläche will die Bundesregierung für die Windkraft reservieren. Manche befürchten nun, ganze Wälder würden abgeholzt und schöne Landschaften verschandelt. In dieser interaktiven Raumanalyse zeigen wir, wo in Hessen das Potenzial für die konfliktfreien Räder schlummert.</div>
          <div class="authors">JENS GIESEL, DANA HAJEK, Oliver Schlömer</div>
        </div>
      </a>
      <p>
        <b>Woher stammen die Daten?</b><br>
        Die Windpotentialflächen wurden auf Basis öffentlich verfügbarer Daten berechnet. Zunächst wurden Flächen mit ausreichender Windleistung und moderater Hangneigung ermittelt. Von diesen wurden verschiedene Ausschlussgebiete subtrahiert, darunter Siedlungsgebiete, Straßen und Schienenwege, Flughäfen, Drehfunkfeuer, Wetterradare, Natur- und Trinkwasserschutzgebiete. Die übrig bleibenden Potentialflächen erfüllen die Grundvoraussetzungen für die Windkraft-Nutzung. Für die konkrete Festlegung von Windkraft-Standorten sind allerdings weitere Faktoren zu berücksichtigen. Hierzu zählen Besitzfragen, militärische Beschränkungen, das Vorkommen seltener Tierarten, Denkmal- und Landschaftsschutz und die Vermeidung der vollständigen Umzingelung von Siedlungen mit Windkraftanlagen.
      </p>
      <table>
        <tr>
          <td>Vorrangflächen für Windenergie</td><td><a href="https://landesplanung.hessen.de/aktuelles/wms-wfs-dienste-landes-regionalplanung" target="_blank">Hessisches Ministerium für Wirtschaft, Energie, Verkehr und Wohnen</a> (Regionalpläne Nord-, Mittel-, und Südhessen, TPEE 2019)</td>
        </tr>
        <tr>
          <td>Siedlungsflächen</td><td><a href="https://gdz.bkg.bund.de/index.php/default/digitales-landschaftsmodell-1-250-000-ebenen-dlm250-ebenen.html" target="_blank">DLM250</a>, OpenStreetmap</td>
        </tr>
        <tr>
          <td>Straßen, Schienen (Puffer: 100m, 250m)</td><td><a href="https://gdz.bkg.bund.de/index.php/default/digitales-landschaftsmodell-1-250-000-ebenen-dlm250-ebenen.html" target="_blank">DLM250</a></td>
        </tr>
        <tr>
          <td>Flughäfen, Landeplätze (Puffer: 5000m, 2000m)</td><td><a href="https://gdz.bkg.bund.de/index.php/default/digitales-landschaftsmodell-1-250-000-ebenen-dlm250-ebenen.html" target="_blank">DLM250</a></td>
        </tr>
        <tr>
          <td>Drehfunkfeuer, Wetterradare (Puffer: 3000m, 5000m)</td><td><a href="https://de.wikipedia.org/wiki/Drehfunkfeuer#Liste_der_VORs_in_Deutschland" target="_blank">Deutsche Flugsicherung</a>, Deutscher Wetterdienst</td>
        </tr>
        <tr>
          <td>Naturschutzgebiete, Nationalpark „Kellerwald-Edersee“, Vogelschutzgebiete, Fauna-Flora-Habitat-Gebiete (FFH-Gebiete)</td><td><a href="https://natureg.hessen.de/infomaterial/geodaten.php" target="_blank">Hessisches Ministerium für Umwelt, Klimaschutz, Landwirtschaft und Verbraucherschutz (HLNUG)</a></td>
        </tr>
        <tr>
          <td>Trinkwasserschutzgebiete (Zonen I und II)</td><td><a href="https://www.hlnug.de/themen/wasser/wasserschutzgebiete" target="_blank">HLNUG</a></td>
        </tr>
        <tr>
          <td>Windleistung (>200 Watt/m²)</td><td>Eigene Berechnung auf Basis von Daten zur Windgeschwindigkeit von <a href="https://globalwindatlas.info/" target="_blank">Global Windatlas</a></td>
        </tr>
        <tr>
          <td>Hangneigung (> 15 Grad)</td><td>Eigene Berechnung auf Basis des <a href="https://gdz.bkg.bund.de/index.php/default/digitales-gelandemodell-gitterweite-200-m-dgm200.html" target="_blank">DGM200</a></td>
        </tr>
        <tr>
          <td>Windkraftanlagen</td><td><a href="https://www.hlnug.de/themen/windenergie" target="_blank">HLNUG</a></td>
        </tr>
      </table>
    </div>
    <div id="mapContainer" class="basemap"></div>
    <div class="settingsBox" :class="{open: legendOpen}">
      <div v-if="!legendOpen" class="legendButton" @click="toggleLegend">Einstellungen</div>
      <div v-else>
        <!-- <div>
          <input type="checkbox" :id="layers[0].id" @click="toggleWindpotential" v-model="layers[0].visible" :class="layers[0].color">
          <label :for="layers[0].id">{{layers[0].label}}</label>
        </div>
        
        <div>
          <input type="checkbox" :id="layers[1].id" @click="toggleLayer(layers[1].id)" v-model="layers[1].visible" :class="layers[1].color">
          <label :for="layers[1].id">{{layers[1].label}}</label>
        </div> -->

        <div v-for="(layer, index) in layers.slice(0,2)" :key="'layler'+index">
          <input type="checkbox" :id="layer.id" @click="toggleLayer(layer.id)" v-model="layer.visible" :class="layer.color">
          <label :for="layer.id">{{layer.label}}</label>
          <div v-if="layer.description" class="infoButton">i<span>{{layer.description}}</span></div>
        </div>

        <div class="wka">
          <div class="hl">Windkraftanlagen</div>
          <div v-for="(layer, index) in layers.slice(2,5)" :key="'layler'+index">
            <input type="checkbox" :id="layer.id" @click="toggleLayer(layer.id)" v-model="layer.visible" :class="layer.color">
            <label :for="layer.id">{{layer.label}}</label>
          </div>
        </div>

        <!-- <div>
          <input type="checkbox" :id="layers[2].id" @click="toggleSiedlung" v-model="layers[2].visible" :class="layers[2].color">
          <label :for="layers[2].id">Siedlungen  +  </label>
          <label class="switch" @click.prevent="toggleDistance">
            <span class="label">750m Abstand</span>
            <input type="checkbox" v-model="distance">
            <span class="slider round"></span>
            <span class="label">1000m Abstand</span>
          </label>
        </div>

        <div>
          <input type="checkbox" :id="layers[3].id" @click="toggleLayer(layers[3].id)" v-model="layers[3].visible" :class="layers[3].color">
          <label :for="layers[3].id">{{layers[3].label}}</label>
        </div> -->

        <div v-if="!moreLayers && $mq=='sm'" class="moreLayers">
          <a @click="showMoreLayers">Weitere Ebenen ...</a>
        </div>
        
        <v-if v-if="moreLayers || $mq!='sm'">
        <div v-for="layer in layers.slice(5)" :key="layer.id" >
          <input type="checkbox" :id="layer.id" @click="toggleLayer(layer.id)" v-model="layer.visible" :class="layer.color">
          <label :for="layer.id">{{layer.label}}</label>
          <div v-if="layer.description" class="infoButton">i<span>{{layer.description}}</span></div>
        </div>
        </v-if>
        <a class="sourceButton" @click="toggleDescription">Quellen</a>
      </div>
      <div v-if="legendOpen" class="closeButton" @click="toggleLegend">✕</div>
    </div>
    <!-- <div class="zoomInfo">{{zoom}}</div> -->
  </div>
</template>

<script>
import mapboxgl from "!mapbox-gl";
import mapboxglgeocoder from "!mapbox-gl-geocoder";

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      map: null,
      loaded: false,
      vorrangWald: false,
      legendOpen: 1,
      descriptionOpen: 0,
      moreLayers: 0,
      distance: 1,
      webview: 0,
      layers: [
        // {id: 'siedlung-hessen', label: 'Siedlungen', visible: false},
        {
          id: 'windpotential', 
          label: 'Windpotentialfläche', 
          color: 'windpotential',
          visible: true,
          description: 'Dies sind Flächen, die sich gut für Windkraft eignen. Die Berechnung erfolgte anhand der lokalen Windleistung sowie den gesetzlich festgelegten Mindestabständen zu Siedlungsgebieten und anderen Ausschlussflächen. Nicht berücksichtigt werden konnten beispielsweise Besitzfragen, militärische Beschränkungen, das Vorkommen seltener Tierarten, sowie Denkmal- und Landschaftsschutz.'
        },
        {
          id: 'vorranggebiete-wind-hessen', 
          label: 'Vorranggebiete für Windkraft', 
          color: 'vorrang-wind',
          visible: true,
          description: '1,9 Prozent der hessischen Landesfläche ist als Windvorrangfläche ausgewiesen. In diesen Gebieten ist der Bau von Windkraftanlagen erlaubt.'
        },
        {
          id: 'wk-hessen', 
          label: 'in Betrieb', 
          color: 'betrieb',
          visible: true
        },
        {
          id: 'wk-hessen-genehmigungsvefahren', 
          label: 'im Genehmigungsverfahren', 
          color: 'genehmigungsverfahren',
          visible: true
        },
        {
          id: 'wk-hessen-beklagt', 
          label: 'beklagt', 
          color: 'beklagt',
          visible: true
        },
        {
          id: 'siedlung-hessen', 
          label: 'Siedlungen + 1000m Puffer', 
          color: 'siedlung',
          visible: false
        },
        // {
        //   id: 'siedlung-hessen-1000m', 
        //   label: 'Siedlungen + 1000 Meter Puffer', 
        //   color: 'siedlung',
        //   visible: true
        // },
        // {
        //   id: 'siedlung-hessen-750m', 
        //   label: 'Siedlungen + 750 Meter Puffer',
        //   color: 'siedlung',
        //   visible: false
        // },
        // {id: 'verkehr-hessen', visible: false},
        // {id: 'drehfunk-puffer', visible: false},
        {
          id: 'naturschutzgebiete-hessen', 
          label: 'Naturschutzgebiete',
          color: 'naturschutz',
          visible: false
        },
        // {id: 'trinkwasser-ueberflutung', visible: false},
        // {id: 'vorranggebiete-wind-hessen-fill', visible: false},
        // {id: 'wald-hessen', visible: false},
        {
          id: 'windleistung-150m', 
          label: 'Windleistung', 
          color: 'windleistung',
          visible: false,
          description: 'Windleistung in 150 Meter Höhe. Orange Flächen deuten auf hohe, violette Flächen auf geringere Windleistung hin.'
        }
      ]
    }
  },
  watch: {
  },
  methods: {
    toggleLayer: function (id) {
      let type = this.map.getLayer(id).type

      let opacity = this.map.getPaintProperty(id, type + '-opacity')
      opacity = opacity == 1 ? 0 : 1
      this.map.setPaintProperty(id, type + '-opacity', opacity)

      if(id == 'siedlung-hessen') {
        this.toggleLayer('siedlung-hessen-1000m')
      }
    },
    toggleLegend () {
      this.legendOpen = !this.legendOpen
      if(this.legendOpen == 0) {
        this.moreLayers = 0
      }
    },
    toggleDescription () {
      this.descriptionOpen = !this.descriptionOpen
    },
    showMoreLayers () {
      this.moreLayers = !this.moreLayers
    },
    toggleDistance () {
      this.distance = !this.distance
      if(this.layers[2].visible) {
        if(this.distance) {
          this.map.setPaintProperty('siedlung-hessen-750m', 'fill-opacity', 0)
          this.map.setPaintProperty('siedlung-hessen-1000m', 'fill-opacity', 1)
        } else {
          this.map.setPaintProperty('siedlung-hessen-750m', 'fill-opacity', 1)
          this.map.setPaintProperty('siedlung-hessen-1000m', 'fill-opacity', 0)
        }
      }
      if(this.layers[0].visible) {
        if(this.distance) {
          this.map.setPaintProperty('windpotential-750', 'fill-opacity', 0)
          this.map.setPaintProperty('windpotential', 'fill-opacity', 1)
        } else {
          this.map.setPaintProperty('windpotential-750', 'fill-opacity', 1)
          this.map.setPaintProperty('windpotential', 'fill-opacity', 0)
        }
      }
    }
  },
  computed: {
    zoom: function () {
      if (this.loaded){
        return this.map.getCenter() + ' / Zoom: ' + this.map.getZoom()
      } else {
        return ''
      }
    }
  },
  mounted () {
    mapboxgl.accessToken = 'pk.eyJ1IjoiamVuc2dpZXNlbCIsImEiOiJja3FhcGcyM28wZmF4MnRsOXZtNnFxejBrIn0.W83tjxWJI1M0uVFYf2EBLg';
    
    this.map = new mapboxgl.Map({
      container: "mapContainer",
      style: "mapbox://styles/jensgiesel/cl3y9fjfs007915pe9xsjqidx", 
      center: [8.8, 50.2],
      zoom: 9,
      // maxBounds: [
      //   [103.6, 1.1704753],
      //   [104.1, 1.4754753],
      // ],
    });

    const nav = new mapboxgl.NavigationControl();
    this.map.addControl(nav, "bottom-right");

    const geocoder = new mapboxglgeocoder({
      // Initialize the geocoder
      accessToken: mapboxgl.accessToken, // Set the access token
      language: 'de',
      mapboxgl: mapboxgl, // Set the mapbox-gl instance
      // marker: false // Do not use the default marker style
      placeholder: 'Ort in Hessen suchen'
    });

    // console.log(geocoder)

    // Add the geocoder to the map
    this.map.addControl(geocoder);

    this.map.on('load', () => {
      this.loaded = true
      this.layers.forEach( layer => {
        if (layer.visible == true) {
          this.toggleLayer(layer.id)
        }
      })
    })

    let standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test( userAgent ),
    ios = /iphone|ipod|ipad/.test( userAgent );

    // console.log(standalone, userAgent, safari, ios)
    if( ios && !standalone && !safari ) {
      this.webview = 1
    }
  }
}
</script>

<style lang="css">
@import './assets/mapbox-gl';
@import './assets/mapbox-gl-geocoder.css';

body {
  margin: 0;
  padding: 0;
}

.mapboxgl-ctrl-top-right {
  top: 87px;
  right: 0;
  width: 100%;
  margin: 0;
  float: unset;
  padding: 10px 20px;
}
@media screen and (max-width: 600px) {
  .mapboxgl-ctrl-top-right {
    top: 77px;
    padding: 5px;
  }
}

.mapboxgl-ctrl-top-right .mapboxgl-ctrl {
  margin: 0;
  float: unset;
}

.mapboxgl-ctrl-geocoder {
  padding: 5px 10px;
  margin: 10px 20px;
  background-image: url("./assets/icons/suche-19-x-20.svg");
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: 93% 50%;
  background-color: rgba(0,0,0,.66);
  backdrop-filter: blur(5px);
  /* border: 1px solid #555; */
  border-radius: 6px;
  /* top: 85px; */
  max-width: 375px;
  color: #fff;
}
.mapboxgl-ctrl-geocoder:focus, .mapboxgl-ctrl-geocoder:active {
  color: #fff;
}
@media screen and (min-width: 640px) {
  .mapboxgl-ctrl-geocoder {
    width: 100%;
    font-size: 15px;
    line-height: 20px;
  }
}

.mapboxgl-ctrl-geocoder input[type="text"] {
  appearance: none;
  border: none;
  background: transparent;
  height: 40px;
  font-family: 'FAZ Gold', sans-serif;
  width: 100%;
  color: #fff;
  font-size: 16px;
}

.geocoder-icon-close, .geocoder-pin-right {
  display: none;
}

.mapboxgl-ctrl-geocoder .suggestions {
  background-color: #000;
}

.mapboxgl-ctrl-geocoder .suggestions > .active > a, 
.mapboxgl-ctrl-geocoder .suggestions > li > a:hover {
    color: #ddd;
    background-color: #222;
}

.mapboxgl-ctrl-geocoder .suggestions > li > a {
    color: #ddd;
}

a.mapboxgl-ctrl-logo {
  display: none;
}

.mapboxgl-ctrl-bottom-right .mapboxgl-ctrl-group {
  margin: 0 20px 10px 0;
  filter: invert(1);
}

.mapboxgl-ctrl.mapboxgl-ctrl-attrib {
  background-color: rgba(0,0,0,.75);
}

.mapboxgl-ctrl-attrib a {
  color: #666;
}

#plusannouncementwidget, #footer, #newFooter, #newFooterM, #taboolawidget {
  display: none;
}
</style>

<style lang="scss">
@import './assets/fonts.scss';
@import './assets/style.scss';
</style>